module.exports = __webpack_public_path__ + "img/letter.9ec5aacb.png";